import classnames from 'classnames'

import AVATAR from 'assets/icons/profile_placeholder.png'

const Ranking = ({ name, position, image, me, index }) => {
  const blurFilter = me ? null : { filter: 'blur(5px)' }

  return (
    <div
      className={classnames(
        'flex justify-between items-center mb-2 rounded-xl w-full px-4 py-4 bg-cover cover md:px-5 ',
        {
          'bg-codGrayLighter': me,
          'px-5 py-3.5 transform scale-95 blur-lg bg-darkBlack': !me,
        }
      )}
      style={
        me
          ? {
              boxShadow: '0px 4px 60px rgba(43, 124, 119, 0.25)',
            }
          : null
      }
    >
      <div className="flex items-center">
        {!image && (
          <div
            className="flex items-center justify-center w-10 h-10 object-cover rounded-full mr-4 md:mr-5 md:w-14 md:h-14"
            style={{ background: '#141414' }}
          >
            <img src={AVATAR} alt={name} className="w-7 h-7" />
          </div>
        )}
        {image && (
          <img
            src={image}
            alt={name}
            className="w-10 h-10 object-cover rounded-full mr-4 md:mr-5 md:w-14 md:h-14"
            style={{ ...blurFilter }}
          />
        )}
        <div className="font-semibold text-base" style={{ ...blurFilter }}>
          {name}
        </div>
      </div>
      <div
        className={classnames('pl-2 text-center flex-shrink-0', {
          'text-lg md:text-xl font-bold': me,
          'text-base font-semibold': !me,
        })}
        style={
          !me
            ? {
                paddingLeft: `${position.toString().length + 5 + index * 6}px`,
              }
            : null
        }
      >
        #{position.toString()}
      </div>
    </div>
  )
}

export default Ranking
